var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#00022F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 2.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 15,
    width: 9.5,
    height: 2,
    rx: 1,
    fill: "#FAFF00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 9.5,
    height: 2,
    rx: 1,
    fill: "#FAFF00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4749,
    y: 12.1109,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-45 18.4749 12.1109)",
    fill: "#FF6B00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.39343,
    y: 25.1924,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-45 5.39343 25.1924)",
    fill: "#FF6B00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-90 15 30)",
    fill: "#0094FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.5,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-90 15 11.5)",
    fill: "#0094FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1924,
    y: 26.6066,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-135 25.1924 26.6066)",
    fill: "#FF6B00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1109,
    y: 13.5251,
    width: 9.5,
    height: 2,
    rx: 1,
    transform: "rotate(-135 12.1109 13.5251)",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec1573e49c57d484d05c54695d58e884.svg";
export { ForwardRef as ReactComponent };